import { api2 } from "../controllers/api";

export const userLoginAPI = async (payload) => {
  try {
    const url = `/account/login`;
    const result = api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};
/**
 * @param {string} [token] - Optional auth token (e.g. from OTP login). If not passed, api2 uses Cookies.get("authToken").
 */
export const getUserAccountDetailsAPI = async (token) => {
  try {
    const url = "/account";
    const props = token != null && token !== "" ? { token } : {};
    const result = await api2.get(url, props);
    return result;
  } catch (error) {
    throw error;
  }
};
export const userListApi = async (userRole) => {
  try {
    const url = `/account/only?page=1&limit=1000000`;
    // if (userRole === "admin") {
    //   url += `&inactive=true`;
    // }
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

//Get List of SDMs in Hub if called by role other than admin. For admins lists all the SDMs
export const getSDMsList = async () => {
  try {
    const url = `/account/get/allSDMsInAHub`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const createMappingSDMtoDM = async (payload) => {
  try {
    const url = `/account/account_mapping`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

// PUT /account/account_mapping
// Request Body :{
//     "primary_account_id": "15cae882-b6d3-40ac-ab12-57311fe40173",
//     "secondary_account_id": "69102ac5-5020-4718-9df0-2c02beb0809d"
// }
export const removeMappingSDMtoDM = async (payload) => {
  try {
    const url = `/account/account_mapping`;
    // const result = await api2.put(url, payload)
    const result = await api2.delete(url, payload);
    // const result = {}
    return result;
  } catch (error) {
    throw error;
  }
};

export const getUserDetailsByIdAPI = async (userId) => {
  const url = `/account/getUserByID/${userId}`;
  try {
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
///hub/mapping

export const createMappingAccountToHubAPI = async (payload) => {
  try {
    const url = `/hub/mapping`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const createMappingAccountToRoleAPI = async (payload) => {
  try {
    const url = `/account/rolemapping`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const removeMappingAccountToRoleAPI = async (payload) => {
  try {
    const url = `/account/rolemapping/delete/`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const removingMappingAccountToHubAPI = async (payload) => {
  try {
    const url = `/hub/mapping/delete`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getSingleUserDetails = async (accountId) => {
  try {
    const url = `/account/getUserByID/${accountId}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

//new API Integration
export const updateUserDetailsPUT = async (accountId, obj) => {
  try {
    const url = `/account/${accountId}`;
    const result = await api2.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const changePasswordAPI = async (payload) => {
  // api used to change password
  // old_password
  //  new_password
  try {
    const url = `/account/changepassword`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const createUserAPI = async (payload) => {
  try {
    const url = `/account/createaccount`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateAccountPrioritisationAPI = async (payload) => {
  // payload: { created_for: "account_id", priority: "high" | "low" | null }
  try {
    const url = `/account/account/prioritisation`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const changeAccountStatusAPI = async (payload) => {
  // payload: { account_id: "uuid", status: "active" | "inactive" }
  try {
    const url = `/account/changestatus`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};
